import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, Subject } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';
import { IGetCodes } from 'src/app/interfaces/codes';
import { ICoursePlanMockExam, IMockExam } from 'src/app/Models/ExamAgencies';
import { ContentManagementService } from 'src/app/Services/content-management/content-management.service';
import { ExamManagementService } from 'src/app/Services/exam-management/exam-management.service';
import { SessionService } from 'src/app/Services/session.service';
import { ConstantVars } from 'src/app/utils/constants/constants';

@Component({
  selector: 'app-add-edit-mock-exam-modal',
  templateUrl: './add-edit-mock-exam-modal.component.html',
  styleUrls: ['./add-edit-mock-exam-modal.component.css'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class AddEditMockExamModalComponent implements OnInit {
  @Input() MockExam: IMockExam;
  addEditForm: FormGroup;
  statuses: IGetCodes[] = [];
  courses: IGetCodes[] = [];
  selectedCourses: string[] = [];
  courseId: number;
  availableCourseType: any[] = [];
  CourseAppliableCourseType: ICoursePlanMockExam[];
  private destroy$ = new Subject<void>();
  examSeriesType: IGetCodes[];

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private examService: ExamManagementService,
    public contentservice: ContentManagementService,
    public session: SessionService,
    private readonly toaster: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.addEditForm = this.fb.group({
      mockExamId: [{ value: '', disabled: true }],
      mockExamSeqNumber: [{ value: '', disabled: true }],
      mockExamName: [null],
      status: ['', Validators.required],
      examSeriesType:['',Validators.required],
      applicableCourses: [[]],
      totalScore: [0],
      noOfQuestion: [0],
    });
    if (this.MockExam) {
      this.addEditForm.patchValue({
        mockExamId: this.MockExam.Course_Test_Id,
        mockExamSeqNumber: this.MockExam.Mock_Exam_Sequence_Number,
        status: this.MockExam.Mock_Exam_Status_Type_Code,
        examSeriesType: this.MockExam.Exam_Series_Type_Code,
        totalScore: this.MockExam.Total_Score,
        noOfQuestion: this.MockExam.Number_Of_Questions,
      });
    }
    this.route.queryParams
      .pipe(takeUntil(this.destroy$))
      .subscribe((params) => {
        this.courseId = +params['c_id'];

      });

    const appliableCoursePlan = {};
    forkJoin({
      statuses: this.examService.getMockExamsStatusTypes().pipe(
        catchError((error) => {
          console.error('Error fetching statuses:', error);
          return of([]);
        })
      ),
      courses: this.contentservice
        .GetCode({ Tablename: 'COURSE_PLAN_TYPE' })
        .pipe(
          catchError((error) => {
            console.error('Error fetching courses:', error);
            return of([]);
          })
        ),
      availableCourseType: this.contentservice
        .getCoursePlan$(
          this.session.getUser(),
          this.courseId,
          '',
          'ASSIGNMOCKEXAM',
          '',
          ''
        )
        .pipe(
          catchError((error) => {
            return of({ coursePlan: [] });
          })
        ),
      applicableCoursePlan: this.examService
        .getMockExamApplicableCoursePlan({
          ScreenName: 'ASSIGNMOCKEXAMTOCOURSEPLAN',
          CourseTestID: this.MockExam ? this.MockExam.Course_Test_Id : null,
          CourseID: this.MockExam ? this.courseId : 0,
          CoursePlanID: null,
          SelectedInd: null,
        })
        .pipe(
          catchError((error) => {
            console.error('Error fetching applicable course type:', error);
            return of([]); // ✅ Return an empty array instead of null
          })
        ),
    }).subscribe(
      ({
        statuses,
        courses,
        availableCourseType,
        applicableCoursePlan, // ✅ Ensure this key matches the `forkJoin` observable key
      }: {
        statuses: any;
        courses: any;
        availableCourseType: any;
        applicableCoursePlan: ICoursePlanMockExam[]; // ✅ Corrected key name
      }) => {
        this.statuses = [...statuses];
        this.courses = courses;
        this.availableCourseType = availableCourseType.coursePlan;
        this.selectedCourses =
          applicableCoursePlan
            .filter((e) => e.Deleted_Ind === 'N')
            .map((e) => e.Course_Plan_Type_Code) ?? [];
        this.CourseAppliableCourseType = applicableCoursePlan ?? []; // ✅ Ensure it's an array
      }
    );

    this.getExamSeriesType()
  }


  getExamSeriesType (){
    return  this.examService.getExamSeriesType().subscribe({
      next:(res)=>{console.log(res)

        this.examSeriesType = res
      },
      error:(err)=>{console.log(err)}
    })
  }

  preventDecimal(event: KeyboardEvent) {
    if (event.key === '.' || event.key === ',' || event.key === 'e') {
      event.preventDefault();
    }
  }
  onCourseChange(event: any) {
    if (event.target.checked) {
      this.selectedCourses.push(event.target.value);
    } else {
      this.selectedCourses = this.selectedCourses.filter(
        (c) => c !== event.target.value
      );
    }
    this.addEditForm.patchValue({ applicableCourses: this.selectedCourses });
  }
  disablecheckboxes(type: string) {
    return !this.availableCourseType.some(
      (ele) => ele.Course_Plan_Type_Code === type
    );
  }
  selectedcheckboxes(type: string) {
    return this.selectedCourses.some((ele) => ele === type);
  }
  checkedCoursePlan(type: string): boolean {
    return this.CourseAppliableCourseType.some(
      (e) => e.Course_Plan_Type_Code === type && e.Deleted_Ind === 'N'
    );
  }
  onSubmit() {
    if (this.addEditForm.valid) {
      const payload = {
        CourseId: this.courseId,
        StudentId: null,
        TestTypeCode: 'MockExam',
        ExamSeriesTypeCode: this.addEditForm.get('examSeriesType')?.value,
        CourseTestId: this.MockExam ? this.MockExam.Course_Test_Id : null,
        TestName: this.addEditForm.get('mockExamName')?.value,
        TestSequenceNumber: null,
        TotalScore: +this.addEditForm.get('totalScore')?.value,
        NumberOfQuestions: +this.addEditForm.get('noOfQuestion')?.value,
        CourseTestStatusTypeCode: this.addEditForm.get('status')?.value,
        TestQuestionDifficultyLevelTypeCode: 'Mixed',
        UDTMockExamApplicableCoursePlan: this.availableCourseType.map(
          (e: any) => {
            return {
              CoursePlanID: +e.Course_Plan_Id,
              SelectedInd: this.selectedcheckboxes(e.Course_Plan_Type_Code)
                ? 'Y'
                : 'N',
            };
          }
        ),
      };

      this.examService.addEditMockExam(payload).subscribe(
        (res: any) => {

          this.toaster.success('Mock ExamCreated', '', {
            timeOut: ConstantVars.ToastSucessTimeout,
          });
          this.activeModal.close(this.MockExam ? this.MockExam.Course_Test_Id: res?.NewCourseTestId);
        },
        (error: any) => {
          this.toaster.error('Something went wrong', '', {
            timeOut: ConstantVars.ToastErrorTimeout,
          });
        }
      );
    } else {
      this.addEditForm.markAllAsTouched();
    }
  }

  setSelectedExamId(id: number | null) {
    this.examService.setSelectedExamId(id);
  }

  ngOnDestroy(): void {
    const currentUrl = this.router.url;

    const shouldKeepSelection =
    currentUrl.includes('Exam/MockExams') ||
      currentUrl.includes('Exam/MockExamsQuestion') ||
      currentUrl.includes('Exam/AddEditMockExamsQuestion');

    if (!shouldKeepSelection) {
      this.setSelectedExamId(null); // Clear the selection
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
